<script>
    import { linspace } from "@saehrimnir/druidjs/dist/druid.min.js"
    import { select, axisBottom, scaleLinear, format } from "d3";
    import { afterUpdate } from "svelte";
    export let value;
    export let width;
    export let height;
    export let margin;

    $: w = 24
    $: value_width = scaleLinear([-1, 4], [margin, width - margin])
    $: pos0 = value_width(0);

    const rand = Math.random()
    let axis
    afterUpdate(() => {
        const a = select(axis)
        a.call(axisBottom(value_width).ticks(3))    
        a.attr("font-family", null).attr("font-size", "9px")
        a.selectAll("path").attr("stroke", "#555")
        a.selectAll("line").attr("stroke", "#555")
        a.selectAll("text").attr("fill", "#555")
    })
</script>


<svg width={width} height={height}>
    <defs>
        <clipPath id="val{rand}">
            <path 
                d="M {pos0} {margin} v {24} H {value_width(value)} v {-24} Z"
                fill="white"
            ></path>
        </clipPath>      
    </defs>

    {#each linspace(margin, width - 24 - margin, 5) as x, i}
        <g transform="translate({value_width(i - 1)}, {margin}) scale(.8)">
            {#if i == 0}
                <path fill="#333" d="M2.39 1.73L1.11 3L3.19 5.08C2.45 6 2 7.19 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C14.32 19.24 15.14 18.5 15.9 17.79L20 22L21.27 20.73M12.1 18.55L12 18.65L11.89 18.55C7.14 14.24 4 11.39 4 8.5C4 7.74 4.22 7.06 4.61 6.5L14.5 16.37C13.74 17.06 12.95 17.78 12.1 18.55M8.3 5.1L6.33 3.13C6.7 3.05 7.1 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 10.84 20.69 12.92 18.47 15.27L17.06 13.86C18.91 11.88 20 10.2 20 8.5C20 6.5 18.5 5 16.5 5C15.1 5 13.74 5.83 13.11 7H10.89C10.38 6.06 9.39 5.34 8.3 5.1Z" />
            {:else}
                 <path fill="#333" d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" />
            {/if}
        </g>
    {/each}
    <g bind:this={axis} transform="translate(0, {margin + 24})"></g>
    <g clip-path="url(#val{rand})">
        {#each linspace(margin, width - 24 - margin, 5) as x, i}
            <g transform="translate({value_width(i - 1)}, {margin}) scale(.8)">
                {#if i == 0}
                    <path fill="currentColor" d="M1,4.27L2.28,3L20,20.72L18.73,22L15.18,18.44L13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,7.55 2.23,6.67 2.63,5.9L1,4.27M7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,11.07 20.42,13.32 17.79,15.97L5.27,3.45C5.95,3.16 6.7,3 7.5,3Z" />
                {:else}
                    <path fill="currentColor" d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
                {/if}
            </g>
        {/each}
    </g>
    <text>{value}</text>
    <title>{format(".2f")(value)}</title>
</svg>